export default "/_next/static/images/img3-088e69365b20e9299f2cd6309199ccc7.png";